__turbopack_context__.v({
  "actionMenuItemStyle": "styles-module__x8OyDW__actionMenuItemStyle",
  "actionMenuItemStyleBlock": "styles-module__x8OyDW__actionMenuItemStyleBlock",
  "actionMenuItemStyleCenter": "styles-module__x8OyDW__actionMenuItemStyleCenter",
  "actionMenuItemStyleMinimal": "styles-module__x8OyDW__actionMenuItemStyleMinimal",
  "mobileOverlay": "styles-module__x8OyDW__mobileOverlay",
  "mobileWrapper": "styles-module__x8OyDW__mobileWrapper",
  "wrapper": "styles-module__x8OyDW__wrapper",
});
